<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16">Informações do último mês</strong>
    </div>
    <div class="row">
      <div class="col-xl-4" v-for="(chartCard, index) in chartCardData" :key="index">
        <cui-chart-card
          :title="chartCard.title"
          :amount="chartCard.amount"
          :chartData="chartCard.chartData"
        />
      </div>
    </div>

<!--    Charts Begin -->

<div class="row">
      <div class="col-lg-4">
        <div class="card card--fullHeight">
          <div class="card-header">
            <div class="utils__title utils__title--flat">
              <strong class="text-uppercase font-size-16">Risco de Fragilidade da Carteira</strong>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-xl-6">
                <div class="mb-3">
                  <a-table
                    :columns="supportCasesTableColumns"
                    :dataSource="supportCasesTableData"
                    :pagination="false"
                    class="utils__scrollTable"
                    :scroll="{ x: '100%' }"
                  >
                    <span
                      slot="amount"
                      slot-scope="data"
                      :class="[data === '1' ? 'text-danger' : 'text-primary', 'font-weight-bold']"
                    >{{data}}</span>
                  </a-table>
                </div>
              </div>
              <div class="col-xl-6">
                <div
                  class="h-100 d-flex flex-column justify-content-center align-items-center"
                  :class="$style.chartPieExample"
                >
                  <vue-chartist
                    type="Pie"
                    :data="supportCasesPieData"
                    :options="supportCasesPieOptions"
                  />
<!--                  <div class="text-center mt-2">-->
<!--                    <span class="mr-2 mt-1 d-inline-block">-->
<!--                      <cui-donut type="success" name="Ready"></cui-donut>-->
<!--                    </span>-->
<!--                    <span class="mr-2 mt-1 d-inline-block">-->
<!--                      <cui-donut type="primary" name="In progress"></cui-donut>-->
<!--                    </span>-->
<!--                    <span class="mr-2 mt-1 d-inline-block">-->
<!--                      <cui-donut type="danger" name="Defected"></cui-donut>-->
<!--                    </span>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card card--fullHeight">
          <div class="card-header">
            <div class="utils__title utils__title--flat">
              <strong class="text-uppercase font-size-16">Sinistralidade (por Segmento de Risco)</strong>
            </div>
          </div>
          <div class="card-body">
               <div

                  :class="$style.chartBarExample"
                >
                  <vue-chartist
                    class="height-300"
                    type="Bar"
                    :data="horizontalData"
                    :options="horizontalOptions"
                  />
                </div>

          </div>
        </div>
      </div>
       <div class="col-lg-4">
              <div class="card card--fullHeight">
                <div class="card-header">
                  <div class="utils__title utils__title--flat">
                    <strong class="text-uppercase font-size-16">NPS (por Segmento de Risco)</strong>
                  </div>
                </div>
                <div class="card-body">
                     <div

                        :class="$style.chartBarExample"
                      >
                        <vue-chartist
                          class="height-300"
                          type="Bar"
                          :data="NPSData"
                          :options="horizontalOptions"
                        />
                      </div>

                </div>
              </div>
       </div>
      </div>

<!--    Charts End-->
  </div>
</template>

<script>

import VueChartist from 'v-chartist'
import ChartistTooltip from 'chartist-plugin-tooltips-updated'

import data, {
  supportCasesTableData,
  supportCasesPieData,
  horizontalData,
  NPSData,
} from './data.json'

import CuiChartCard from '@/components/CleanUIComponents/ChartCard'

const supportCasesTableColumns = [
  {
    title: 'Risco',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: '#',
    key: 'key',
    dataIndex: 'amount',
    scopedSlots: { customRender: 'amount' },
  },
]

const horizontalOptions = {
  seriesBarDistance: 10,
  reverseData: !0,
  horizontalBars: !0,
  axisY: {
    offset: 70,
  },
  plugins: [ChartistTooltip({ anchorToPoint: false, appendToBody: true, seriesName: false })],
}

const supportCasesPieOptions = {
  donut: true,
  donutWidth: 35,
  showLabel: false,
  fullWidth: true,
  plugins: [
    ChartistTooltip({
      anchorToPoint: false,
      appendToBody: true,
      seriesName: false,
    }),
  ],
}

const referalsColumns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Position',
    dataIndex: 'position',
    key: 'position',
  },
  {
    title: 'Age',
    dataIndex: 'age',
    key: 'age',
    sorter: (a, b) => a.age - b.age,
  },
  {
    title: 'Office',
    dataIndex: 'office',
    key: 'office',
  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
  },
  {
    title: 'Salary',
    dataIndex: 'salary',
    key: 'salary',
    sorter: (a, b) => a.salary - b.salary,
  },
]

export default {
  components: {
    'vue-chartist': VueChartist,
    CuiChartCard,
  },
  data: function () {
    return {
      chartCardData: data.chartCardData,
      paymentAccountsData: data.paymentAccountsData,
      paymentCardsData: data.paymentCardsData,
      paymentTransactionsData: data.paymentTransactionsData,
      // progressCardsData: data.progressCardsData,
      referalsData: data.referalsData,
      referalsColumns,
      supportCasesTableData,
      supportCasesTableColumns,
      supportCasesPieData,
      supportCasesPieOptions,
      horizontalOptions,
      horizontalData,
      NPSData,
    }
  },

}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
